import { ROLES_SYSTEM } from "@/utils/constant"
import i18n from "@/libs/i18n"

export default [
  {
    title: "lbl_home",
    route: "home",
    icon: "HomeIcon",
    role: [ROLES_SYSTEM.ALL],
  },
  {
    title: "lbl_orders",
    route: "orders",
    icon: "PackageIcon",
    role: [ROLES_SYSTEM.SUPPLIER],
  },
  {
    title: "lbl_orders",
    route: "orders-market-place",
    icon: "PackageIcon",
    role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
  },
  {
    title: "lbl_required_test_manager",
    route: "orders-processor",
    icon: "PackageIcon",
    role: [ROLES_SYSTEM.PROCESSOR],
  },
  {
    title: "lbl_inventory",
    route: "inventory",
    icon: "DatabaseIcon",
    role: [ROLES_SYSTEM.SUPPLIER],
  },
  {
    title: "lbl_product___services",
    route: "products",
    icon: "ShoppingBagIcon",
    role: [ROLES_SYSTEM.SUPPLIER],
  },

  {
    title: "lbl_inventory_management",
    route: "inventory-product",
    icon: "DatabaseIcon",
    role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
    // children: [
    //   // {
    //   //   title: "lbl_warehouse",
    //   //   route: "warehouse",
    //   //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
    //   // },
    //   // {
    //   //   title: "Nhập/Xuất kho",
    //   //   route: "bill-manager",
    //   //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
    //   // },
    //   // {
    //   //   title: "lbl_qty",
    //   //   route: "inventory-product",
    //   //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
    //   // },
    // ],
  },
  {
    title: "lbl_document_management",
    route: "bill-manager",
    icon: "FileTextIcon",
    role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
    children: [
      {
        title: "Nhập kho",
        route: "import",
        role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
      },
      {
        title: "Xuất kho",
        route: "export",
        role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
      }
    ],
  },

  // Supplier product
  // {
  //   title: i18n.t("lbl_product_category"),
  //   route: "product-category",
  //   icon: "ShoppingBagIcon",
  //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
  // },

  // {
  //   title: i18n.t("lbl_inventory_product"),
  //   route: "inventory-product",
  //   icon: "DatabaseIcon",
  //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
  // },
  // {
  //   title: i18n.t("lbl_bill"),
  //   route: "bill-manager",
  //   icon: "FileTextIcon",
  //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
  // },
  // {
  //   title: i18n.t("lbl_receipt"),
  //   route: "receipt-manager",
  //   icon: "DollarSignIcon",
  //   role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
  // },


  // {
  //   title: i18n.t("lbl_analytics"),
  //   route: "analytics",
  //   icon: "TrendingUpIcon",
  //   role: ROLES_SYSTEM.ALL,
  // },
  // {
  //   title: "lbl_config_settings",
  //   route: "configs",
  //   icon: "SettingsIcon",
  //   role: [ROLES_SYSTEM.SUPPLIER],
  //   children: [
  //     {
  //       title: "lbl_delivery_definition_configs",
  //       route: "config-definition",
  //       role: [ROLES_SYSTEM.SUPPLIER],
  //     },
  //     {
  //       title: "lbl_delivery_status_configs",
  //       route: "config-delivery-status",
  //       role: [ROLES_SYSTEM.SUPPLIER],
  //     },
  //     {
  //       title: "lbl_required_attachment_configs",
  //       route: "config-order-form",
  //       role: [ROLES_SYSTEM.SUPPLIER],
  //     },
  //   ],
  // },
  {
    title: "lbl_product_management",
    route: "config-product",
    icon: "ArchiveIcon",
    role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
    children: [
      {
        title: "lbl_products",
        route: "products-marketplace",
        // icon: "ShoppingBagIcon",
        role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
      },
      {
        title: "lbl_product_information",
        route: "config-product",
        role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
        children: [
          {
            title: "Quy cách đóng gói",
            route: "config-specification",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "Dạng bào chế",
            route: "config-dosage-form",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "lbl_unit",
            route: "config-unit-manager",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "lbl_category",
            route: "config-category",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "Nhà sản xuất",
            route: "config-manufacture-manager",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "Nguồn gốc",
            route: "config-origin",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "lbl_provider",
            route: "config-provider-manager",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
          {
            title: "lbl_brand",
            route: "config-brand-manager",
            role: [ROLES_SYSTEM.SUPPLIER_PRODUCT],
          },
        ],
      },
    ],
  },
  // {
  //   title: "lbl_reports",
  //   route: "reports",
  //   icon: "BarChart2Icon",
  //   role: [ROLES_SYSTEM.SUPPLIER, ROLES_SYSTEM.SUPPLIER_PRODUCT],
  // },
]
